import $ from "jquery";
import {
  isInt,
  isFloat,
  getHeaderHeight,
  forceFocus,
  safe$,
} from "./functions";

const $document = $(document);
const $header = $(".header");
const $elToScroll = $(".page__body");

$document.on("click", ".smoothscroll", function (event) {
  const $thisEl = $(this);
  let selector;
  if ($thisEl.attr("href") !== undefined) {
    event.preventDefault();
    selector = $thisEl.attr("href");
  } else if ($thisEl.data("selector") !== undefined) {
    selector = $thisEl.data("selector");
  } else {
    return;
  }

  let offset = 0;
  if ($thisEl.data("offset") !== undefined) {
    offset = $thisEl.data("offset");
  }

  let animationDuration = 500;
  if ($thisEl.data("animduration") !== undefined) {
    animationDuration = $thisEl.data("animduration");
  }

  let elToScroll = $elToScroll;
  if ($thisEl.data("eltoscroll") !== undefined) {
    elToScroll = $thisEl.data("eltoscroll");
  }

  smoothscroll(selector, offset, animationDuration, elToScroll).then(
    () => $thisEl.trigger("smoothscroll:end"),
    (err) => console.log(err)
  );
});

export const smoothscroll = (
  selector,
  offset = 0,
  animationDuration = 500,
  elToScroll = $elToScroll
) => {
  if (
    (isInt(offset) || isFloat(offset) || offset === "header") &&
    (isInt(animationDuration) || isFloat(animationDuration))
  ) {
    return new Promise((resolve, reject) => {
      let height;

      if (isInt(selector) || isFloat(selector)) {
        height = selector;
      } else {
        selector = safe$(selector);
        !selector && reject("smoothscroll:selector:bad_type");

        try {
          height = selector.position().top + $elToScroll.scrollTop();
        } catch (e) {
          console.log(e);
          reject(e);
        }
      }

      elToScroll = safe$(elToScroll);
      !elToScroll && reject("smoothscroll:elToScroll:bad_type");

      if (offset === "header") {
        let awaitForHeader = false;
        if (elToScroll.scrollTop() === 0) {
          elToScroll.scrollTop(1);
          if (new RegExp("height").test($header.css("transition"))) {
            awaitForHeader = true;
          }
        }
        if (awaitForHeader === true) {
          $header.one("transitionend", () =>
            scrollToHeight(
              height - getHeaderHeight(),
              animationDuration,
              elToScroll,
              selector
            ).then(
              (msg) => resolve(msg),
              (err) => reject(err)
            )
          );
        } else {
          scrollToHeight(
            height - getHeaderHeight(),
            animationDuration,
            elToScroll,
            selector
          ).then(
            (msg) => resolve(msg),
            (err) => reject(err)
          );
        }
      } else {
        scrollToHeight(
          height - offset,
          animationDuration,
          elToScroll,
          selector
        ).then(
          (msg) => resolve(msg),
          (err) => reject(err)
        );
      }
    });
  }
};

const scrollToHeight = (height, animationDuration, elToScroll, elToFocus) => {
  return new Promise((resolve, reject) => {
    if (isInt(height) || isFloat(height)) {
      if (parseInt(elToScroll.scrollTop()) !== parseInt(height)) {
        elToScroll.stop().animate(
          {
            scrollTop: height,
          },
          animationDuration,
          () => {
            // forceFocus(elToFocus);
            resolve("smoothscroll:done");
          }
        );
      } else {
        // forceFocus(elToFocus);
        resolve("smoothscroll:done");
      }
    } else {
      reject("smoothscroll:height_is_not_number");
    }
  });
};
